import { render, staticRenderFns } from "./Categorii-drepturi_dialog.vue?vue&type=template&id=2c8cab14&scoped=true&"
import script from "./Categorii-drepturi_dialog.vue?vue&type=script&lang=js&"
export * from "./Categorii-drepturi_dialog.vue?vue&type=script&lang=js&"
import style0 from "./Categorii-drepturi_dialog.vue?vue&type=style&index=0&id=2c8cab14&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8cab14",
  null
  
)

export default component.exports